document.addEventListener('DOMContentLoaded', function () {

  // --- Restore saved state on page load ---
  const savedCompare = JSON.parse(localStorage.getItem('compareList') || '[]');
  document.querySelectorAll('.bb-compare-btn').forEach(btn => {
    const id = btn.dataset.id;
    const isInCompare = savedCompare.some(p => p.id === id);
    btn.innerHTML = isInCompare
      ? '<i class="ri-check-line"></i>'
      : '<i class="ri-repeat-line"></i>';
  });


  // --- Handle compare button click ---
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.bb-compare-btn');
    if (!btn) return;

    let compareList = JSON.parse(localStorage.getItem('compareList') || '[]');

    // Prepare product info
    let product = {
      id: btn.dataset.id,
      title: btn.dataset.title,
      price: btn.dataset.price,
      image: btn.dataset.image,
      url: btn.dataset.url,
      category: btn.dataset.category,
      brand: btn.dataset.brand,
      stock: btn.dataset.stock,
      sku: btn.dataset.sku,
      weight: btn.dataset.weight,
      description: btn.dataset.description
    };

    const exists = compareList.some(p => p.id === product.id);

    if (exists) {
      // Remove product from list
      compareList = compareList.filter(p => p.id !== product.id);
      btn.innerHTML = '<i class="ri-repeat-line"></i>';
    } else {
      // Add product to list
      compareList.push(product);
      btn.innerHTML = '<i class="ri-check-line"></i>';
    }

    localStorage.setItem('compareList', JSON.stringify(compareList));

    // Show popup with count
    showComparePopup(compareList.length);
  });


  // ---  Popup function ---
  function showComparePopup(count) {
    // Remove any existing popup
    const existing = document.querySelector('.bb-compare-popup');
    if (existing) existing.remove();

    // Create new popup
    const popup = document.createElement('div');
    popup.className = 'bb-compare-popup';
    popup.innerHTML = `
      <h4>Product Compare</h4>
      <p>You have <strong>${count}</strong> product${count !== 1 ? 's' : ''} in your compare list.</p>
      <a href="/pages/compare" class="bb-btn-2">Go to Compare</a>
    `;

    document.body.appendChild(popup);

    // Animate in
    setTimeout(() => popup.classList.add('show'), 50);

    // Auto remove after 5 seconds
    setTimeout(() => {
      popup.classList.remove('show');
      setTimeout(() => popup.remove(), 300);
    }, 5000);
  }
});